visibilityDependencyDataservice.$inject = []

function visibilityDependencyDataservice () {
  var treeList = []
  var lookup = {}
  function init (formFields) {
    treeify(formFields)
    for (var i = 0, l = treeList.length; i < l; i++) {
      var element = treeList[i]
      nodeVisibleChange(element)
    }
  }

  function nodeVisibleChange (node) {
    for (var i = 0, count = node.nodes.length; i < count; i++) {
      var child = node.nodes[i]
      if (child.dependsOnValues && child.dependsOnValues.length > 0) {
        child.isVisible = isVisibleSomeByDefaultValueI18N(child, node.defaultValueI18N)
      }
      nodeVisibleChange(child)
    }
  }

  function isVisibleSomeByDefaultValueI18N (child, defaultValueI18N) {
    for (var i = 0; i < child.dependsOnValues.length; i++) {
      if (child.dependsOnValues[i] === defaultValueI18N) {
        return true
      }
    }
    return false
  }

  function isNodeVisible (id) {
    return lookup[id].isVisible
  }

  function nodeValuesChanged (id, values) {
    var visibleNow = []
    Object.keys(lookup).forEach(function (key) {
      var field = lookup[key]
      if (field.dependsOn === id) {
        field.isVisible = isVisibleByChangedValues(field.dependsOnValues, values)
        if (field.isVisible === true) {
          visibleNow.push(field)
        }
      }
    })
    return visibleNow
  }

  function nodeCheckboxValuesChanged (id, values) {
    var visibleNow = []
    Object.keys(lookup).forEach(function (key) {
      var field = lookup[key]
      if (field.dependsOn === id) {
        field.isVisible = isVisibleByCeckboxValues(field.dependsOnValues, values)
        if (field.isVisible === true) {
          visibleNow.push(field)
        }
      }
    })
    return visibleNow
  }

  function isVisibleByCeckboxValues (dependsOnValues, values) {
    for (var i = 0; i < dependsOnValues.length; i++) {
      if (values.indexOf(dependsOnValues[i]) !== -1) {
        return true
      }
    }
    return false
  }

  function isVisibleByChangedValues (dependsOnValues, values) {
    if (Array.isArray(values)) {
      if (dependsOnValues.toString() === values.toString()) {
        return true
      } else {
        return false
      }
    } else {
      if (dependsOnValues.indexOf(values) !== -1) {
        return true
      } else {
        return false
      }
    }
  }

  function treeify (list, idAttr, parentAttr, childrenAttr, groupAttr) {
    if (!idAttr) idAttr = 'id'
    if (!parentAttr) parentAttr = 'dependsOn'
    if (!childrenAttr) childrenAttr = 'nodes'

    // Create lookup table
    list.forEach(function (obj) {
      lookup[obj['id']] = obj
      obj[childrenAttr] = []
    })

    // Build tree
    list.forEach(function (obj) {
      if (obj[parentAttr] && obj[parentAttr] != null) {
        obj['isVisible'] = false
        lookup[obj[parentAttr]][childrenAttr].push(obj)
      } else {
        obj['isVisible'] = true
        treeList.push(obj)
      }
    })
  }

  return {
    init: init,
    isNodeVisible: isNodeVisible,
    nodeValuesChanged: nodeValuesChanged,
    nodeCheckboxValuesChanged: nodeCheckboxValuesChanged
  }
}

module.exports = visibilityDependencyDataservice
